import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { CheckException } from '@treasury/domain/arp';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/layout/tm-section';
import '@treasury/presentation/components/tm-body';
import '@treasury/presentation/components/tm-footer';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../../components/confirmation-container';
// eslint-disable-next-line no-duplicate-imports
import { ConfirmationType } from '../../../../components/confirmation-container';
import { HeaderBarService } from '../../../../services/jhd-header-bar.service';
import './check-exceptions-review-desktop';
import './check-exceptions-table';

export const tagName = 'check-exceptions-decision-confirmation';
@customElement(tagName)
export class CheckExceptionsReviewConfirmation extends TmBaseComponent {
    @property()
    public successfulDecision = false;

    @property()
    public loading = false;

    @property()
    public checkExceptions: CheckException[] = [];

    @InjectProperty()
    declare private navService: NavigationService;

    @InjectProperty()
    declare private headerService: HeaderBarService;

    public firstUpdated() {
        this.headerService.configure({ backAction: undefined, title: '' });
    }

    public render() {
        const headingText = this.successfulDecision
            ? 'Decisions Submitted'
            : 'Unable to Submit Decisions';
        const subheadingText = this.successfulDecision
            ? 'Your exceptions have been successfully submitted'
            : 'Your exceptions were not submitted';
        const confirmationType = this.successfulDecision
            ? ConfirmationType.Success
            : ConfirmationType.Error;
        return html`
            <confirmation-container
                class="pt-10"
                .headingText=${headingText}
                .subheadingText=${subheadingText}
                .confirmationType=${confirmationType}
                iconSize="small"
            >
                <check-exceptions-table .checkExceptions=${this.checkExceptions} ?readonly=${true}>
                </check-exceptions-table>
            </confirmation-container>
            <tm-footer
                .buttonConfig=${[
                    {
                        importance: 'secondary',
                        text: 'View ACH exceptions',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('close'));
                            this.navService.navigate(`/positive-pay/ach-exceptions`);
                        },
                        size: 'large',
                    },
                    {
                        importance: 'secondary',
                        text: 'View check exceptions',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('close'));
                            this.headerService.configure({
                                title: 'Positive Pay - Checks',
                                menuItems: [],
                            });
                            this.dispatchEvent(
                                new CustomEvent('refresh', { bubbles: true, composed: true })
                            );
                        },
                        size: 'large',
                    },
                ]}
            >
            </tm-footer>
        `;
    }

    public static get styles() {
        return css`
            :host {
                height: 100%;
                display: flex;
                flex-direction: column;
                background-color: var(--container-primary);
            }
            vaadin-grid-cell-content {
                padding: 0;
                height: 100%;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CheckExceptionsReviewConfirmation;
    }
}
